<template>
  <ElDialog
    :visible.sync="visible"
    :custom-class="`el-dialog-clearstyle-class zs-tj-skill-preview`"
    top="5vh"
    width="792px"
    append-to-body
  >
    <div class="skill-preview">
      <div class="header">
        <span class="role-name">角色名称</span>
        <div class="skill-list">
          <div class="skill-item">
            <img class="icon" :src="dataSource.attr1.icon.value" />
            <span class="text">{{ dataSource.attr1.name.value }}</span>
          </div>
          <div class="skill-item">
            <img class="icon" :src="dataSource.attr2.icon.value" />
            <span class="text">{{ dataSource.attr2.name.value }}</span>
          </div>
          <div class="skill-item">
            <img class="icon" :src="dataSource.upgrade['level' + activeLevel].icon.value" />
            <span class="text">{{ dataSource.attr3.name.value }}</span>
          </div>
        </div>
        <div class="close">
          <img src="@/assets/zs_imgs/close-skill-preview.png" />
        </div>
      </div>
      <div class="body">
        <table>
          <thead>
            <tr>
              <th>强化</th>
              <th>消耗</th>
              <th>冷却时间</th>
              <th>技能效果</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key, index) in dataSource.upgrade" :key="key">
              <td>
                <img :src="getLevelIcon(key)" />
              </td>
              <td>消耗</td>
              <td>
                <span>{{ value.cd.value }}</span>
              </td>
              <td>
                <div v-html="highlightNumbers(value.desc.value)"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ElDialog>
</template>
<script>
export default {
  name: "SkillPreview",
  props: {
    value: { type: Boolean, default: false },
    dataSource: { type: Object, default: () => ({ upgrade: {} }) },
    levelMap: { type: Object, default: () => ({}) },
    activeLevel: { type: Number, default: 0 }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(bool) {
        this.$emit("input", bool);
      }
    }
  },
  methods: {
    getLevelIcon(level) {
      const count = level.replace("level", "");
      return this.levelMap[count].icon;
    },
    highlightNumbers(str) {
      return str.replace(/(\d+\.?\d*%?)/g, `<span style="color: #FFBC5E;">$1</span>`);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .zs-tj-skill-preview {
  margin-left: 12vw;
}
.skill-preview {
  display: flex;
  flex-direction: column;
  height: 90vh;
  padding: 26px 20px;
  border-radius: 12px;
  background: linear-gradient(180deg, #262f3a 0%, #252b36 100%), linear-gradient(155deg, #262f3a 0%, #31415e 100%);
  color: #fff;
  .header {
    position: relative;
    display: flex;
    align-items: center;
    column-gap: 20px;
    margin-bottom: 35px;
    .role-name {
      font-size: 40px;
      font-weight: bold;
    }
    .skill-list {
      display: flex;
      align-items: center;
      column-gap: 20px;
      .skill-item {
        display: flex;
        align-items: center;
        column-gap: 8px;
        .icon {
          width: 32px;
          height: 32px;
        }
        .text {
          font-size: 14px;
          font-weight: bold;
          font-family: SimSun;
        }
      }
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      img {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  }
  .body {
    flex-grow: 1;
    height: 0;
    overflow: auto;
    font-size: 16px;
    table {
      width: 100%;
      border-collapse: collapse;
    }
    tr {
      position: relative;
    }
    td {
      border: 1px solid rgba(255, 255, 255, 0.1);
      text-align: center;
      min-width: 100px;
      box-sizing: content-box;
      padding: 16px 12px;
      img {
        width: 44px;
        height: 36px;
      }
    }
    thead tr {
      background-color: rgba(255, 255, 255, 0.08);
      th {
        padding: 8px 0;
        border-left: 1px solid rgba(255, 255, 255, 0.1);
        &:last-child {
          border-right: 1px solid rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
}
</style>
